import { FC, useEffect, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import ProgressMap from '../components/HomePlayer/ProgressMap';
import { getPlayerByHomeUser } from '../../modules/player_api';
import mixpanel from 'mixpanel-browser';

import {
  MixPanelEvent,
  getEventName,
  MixPanelEventTypes,
  mixPanelNavHandler,
  PlatformTypes,
} from '../services/MixPanel';

type Player = {
  home_user: {
    first_name: string;
    last_name: string;
    email: string | null;
    id: number;
    home_progress: number;
  };
};

const HomePlayerDashboard: FC = () => {
  const [player, setPlayer] = useState<Player | false>(false);
  const [started, setStarted] = useState(false);
  const history = useHistory();

  useEffect(() => {
    getPlayerByHomeUser().then((response) => {
      if (response.data.success) {
        const player = response.data.player_data;
        setPlayer(player);

        const event = new MixPanelEvent(
          PlatformTypes.REMOTE_THERAPY,
          'Therapist Dashboard',
          MixPanelEventTypes.VIEW,
          'Player Dashboard'
        );
        mixpanel.track(getEventName(event), event);
      }
    });
  }, []);

  const start = () => {
    setStarted(true);

    mixPanelNavHandler(
      PlatformTypes.REMOTE_THERAPY,
      'Therapist Dashboard',
      MixPanelEventTypes.CLICK,
      'Player Dashboard',
      'Start'
    );
    history.push('/play');
  };

  return (
    <div>{player && !started && <ProgressMap homeUser={player.home_user} startFunc={() => start()}></ProgressMap>}</div>
  );
};

export default withRouter(HomePlayerDashboard);
